import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IRecordNavigationTimingParams {
  // See: http://www.w3.org/TR/navigation-timing/#sec-navigation-timing-interface
  timing: PerformanceTiming;
}

export class RecordNavigationTimingRequest extends Request<IRecordNavigationTimingParams, IResult> {
  constructor(params: IRecordNavigationTimingParams) {
    super('recordNavigationTiming', params);
  }
}
